module.exports = __webpack_public_path__ + "static/dmon-013-8fe03e12242e63d6d57bd0de1c6e3d09.jpg";